var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49976 14.166C2.49976 14.941 2.49976 15.3285 2.58495 15.6464C2.81611 16.5091 3.48998 17.183 4.35271 17.4142C4.67063 17.4993 5.05811 17.4993 5.83309 17.4993H14.1664C14.9414 17.4993 15.3289 17.4993 15.6468 17.4142C16.5095 17.183 17.1834 16.5091 17.4146 15.6464C17.4998 15.3285 17.4998 14.941 17.4998 14.166",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7498 9.58337C13.7498 9.58337 10.988 13.3334 9.99971 13.3334C9.01154 13.3334 6.24976 9.58337 6.24976 9.58337M9.99971 12.5V2.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportBtn);
export default __webpack_public_path__ + "static/media/export_btn.33d7ba4c23f28acbf101ee96b39207c8.svg";
export { ForwardRef as ReactComponent };